import React from 'react';

// Kins Gesicht — „Der freche Funke" (Alexanders Entwurf, 2026-09):
// weißer Avatar mit Augenzwinkern und Grinsen auf Indigo, dazu der
// Teal-Funke. Feste Farben: der Avatar ist Identität und bleibt in
// Hell und Dunkel gleich.
export default function KinAvatar({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" role="img" aria-label="Kin">
      <circle cx="256" cy="256" r="256" fill="#4F46E5" />
      {/* Leichte Neigung gibt der Figur Haltung */}
      <g transform="rotate(-4 256 270)">
        <path
          d="M138 244C138 184 181 143 243 143H274C335 143 376 184 376 244V282C376 342 334 383 273 383H239C178 383 138 342 138 282Z"
          fill="#FFFFFF"
        />
        {/* Augenzwinkern */}
        <path d="M181 247C194 259 211 260 225 246" fill="none" stroke="#14181F" strokeWidth="18" strokeLinecap="round" />
        {/* Waches Auge */}
        <circle cx="310" cy="247" r="17" fill="#14181F" />
        {/* Schräges, selbstbewusstes Grinsen */}
        <path d="M202 309C229 331 270 337 316 304" fill="none" stroke="#14181F" strokeWidth="18" strokeLinecap="round" />
      </g>
      {/* Markenpunkt als kleiner Energieschub */}
      <path
        d="M366 93C368 112 379 123 398 125C379 127 368 138 366 157C364 138 353 127 334 125C353 123 364 112 366 93Z"
        fill="#0E9E97"
      />
    </svg>
  );
}
